export const STATUS_PILL_LABEL = {
  live: "Live",
  upcoming: "Upcoming",
  awarded: "Awarded",
  completed: "Completed",
  submitted: "Submitted",
  not_awarded: "Not awarded",
  no_submission: "No submission",
};
